import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useDispatch } from "react-redux";
import { createUnit } from "../../../actions/unitActions";
import { useSnackbar } from "react-simple-snackbar";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  root: { margin: 0, padding: theme.spacing(2), backgroundColor: "#ef7f1a" },
  closeButton: { position: "absolute", right: theme.spacing(1), top: theme.spacing(1), color: "white" },
  inputStyle: { width: "100%" },
}));

const DialogTitle = (props) => {
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...props}>
      <Typography variant="h6">{props.children}</Typography>
      {props.onClose ? (
        <IconButton className={classes.closeButton} onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const AddBasicUnit = ({ open, setOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openSnackbar] = useSnackbar();
  const [unitData, setUnitData] = useState({ name: "", abbreviation: "" });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(createUnit(unitData, openSnackbar));
      clear();
      setOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUnitData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!unitData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }
    if (!unitData.abbreviation.trim()) {
      newErrors.abbreviation = "Abbreviation is required";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const clear = () => setUnitData({ name: "", abbreviation: "" });

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <DialogTitle onClose={() => setOpen(false)}>New Unit</DialogTitle>
      <MuiDialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Unit Name"
              name="name"
              variant="outlined"
              className={classes.inputStyle}
              value={unitData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Unit Code"
              name="abbreviation"
              variant="outlined"
              className={classes.inputStyle}
              value={unitData.abbreviation}
              onChange={handleChange}
              error={!!errors.abbreviation}
              helperText={errors.abbreviation}
              required
            />
          </Grid>
        </Grid>
      </MuiDialogContent>
      <MuiDialogActions>
        <Button onClick={handleSubmit} variant="contained" style={{ backgroundColor: "#ef7f1a", color: "white" }}>
          Save Unit
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default AddBasicUnit;